import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProposalsService } from 'src/app/services/api/proposals.service';
import { SettingsPaymentTermsFormComponent } from '../../../components/settings-payment-terms-form/settings-payment-terms-form.component';

@Component({
  selector: 'app-payment-terms-edit-page',
  imports: [SettingsPaymentTermsFormComponent],
  templateUrl: './payment-terms-edit-page.component.html',
  styleUrl: './payment-terms-edit-page.component.scss'
})
export class PaymentTermsEditPageComponent {
  paymentTermId!: number
  paymentTerm?: any;

  constructor(
    private route: ActivatedRoute,
    private proposalsService: ProposalsService,
  ) {
  }

  ngOnInit(): void {
    this.paymentTermId = Number(this.route.snapshot.paramMap.get('paymentTermId'));        
    
    if (this.paymentTermId) {
      this.loadData(this.paymentTermId);
    }
  }

  loadData(paymentTermId: any) {    
    this.proposalsService.detailSettingsPaymentTerms(paymentTermId).subscribe((response: any) => {
      this.paymentTerm = response.data?.proposalPaymentConditionType;     
    });
  }
}
